module.exports = __webpack_public_path__ + "static/media/Quail Hollow-1.2fb13db7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-la/Quail Hollow-1.jpg
// module id = 419
// module chunks = 0